import React from "react";
import { Card, Text, Metric } from "@tremor/react";
import { resolveWidgetIcon } from "./widgetIcons";
import { resolveWidgetColor } from "./widgetColors";

const StatTileWidget = ({ widget }) => {
  const value = widget.data;
  const display = value === null || value === undefined ? "—" : Number(value).toLocaleString();
  const iconName = widget.props?.icon;
  const Icon = iconName ? resolveWidgetIcon(iconName) : null;
  const palette = resolveWidgetColor(widget.props?.color);

  return (
    <Card>
      <div className="flex items-center justify-between">
        <div>
          <Text>{widget.title}</Text>
          <Metric>{display}</Metric>
        </div>
        {Icon && (
          <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${palette.bg} ${palette.text}`}>
            <Icon size={20} />
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatTileWidget;
